{
    "walk-one-hour": "Andar",
    "your-family": "Aqueles que Você Ama",
    "miles-to-the-border": "km",
    "you": "você",
    "wife": "esposa",
    "son": "filho",
    "daughter": "filha",
    "day": "dia",
    "daylight": "luz do dia",
    "strength": "Força",
    "speak": "Labia",
    "stealth": "Furtividade",
    "exploration": "Exploração",
    "bag-is-empty": "A bolsa esta vazia"
}